import TemplateView from '../../TemplateView'
import CopySettingsItem from './CopySettingsItem'

export default class CopySettingsBlock extends TemplateView {
    constructor({
        additionalClass = '',
        assignmentsSettings = [],
        descriptionSettings = [],
        taskSettings = [],
    } = {}) {
        super()

        this.state = {
            assignmentsSettings,
            descriptionSettings,
            taskSettings,
        }

        this.additionalClass = additionalClass
        this.settingItems = {}

        this.onStatePropertyChanged('assignmentsSettings', assignmentsSettings => {
            this.$assignmentsSettings.empty()
            assignmentsSettings.forEach(setting => {
                    this.settingItems[setting.id] = new CopySettingsItem(setting).init(this.$assignmentsSettings)
                }
            )

            this.$assignmentsSettings.toggle(assignmentsSettings.length > 0)
        })

        this.onStatePropertyChanged('descriptionSettings', descriptionSettings => {
            this.$descriptionSettings.empty()
            descriptionSettings.forEach(setting => {
                    this.settingItems[setting.id] = new CopySettingsItem(setting).init(this.$descriptionSettings)
                }
            )

            this.$descriptionSettings.toggle(descriptionSettings.length > 0)
        })

        this.onStatePropertyChanged('taskSettings', taskSettings => {
            this.$taskSettings.empty()
            taskSettings.forEach(setting => {
                    this.settingItems[setting.id] = new CopySettingsItem(setting).init(this.$taskSettings)
                }
            )

            this.$taskSettings.toggle(taskSettings.length > 0)
        })
    }

    templateHtml() {
        return '<div class="components_copySettingsBlock <%-additionalClass%>">' +
               '    <div class="title"><%-title%></div>' +
               '    <div class="settingsPlaceholder">' +
               '        <div class="assignmentsSettings"/>' +
               '        <div class="descriptionSettings"/>' +
               '        <div class="taskSettings"/>' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            title: 'task.list.copy_to.settings.copy_with'
        }
    }

    afterRender() {
        this.$assignmentsSettings = this.find('.assignmentsSettings')
        this.$descriptionSettings = this.find('.descriptionSettings')
        this.$taskSettings = this.find('.taskSettings')

        this.$assignmentsSettings.toggle(this.state.assignmentsSettings.length > 0)
        this.$descriptionSettings.toggle(this.state.descriptionSettings.length > 0)
        this.$taskSettings.toggle(this.state.taskSettings.length > 0)

        this.renderInitialState()
    }

    getSelectedSettings() {
        let result = {}
        for (let setting in this.settingItems) {
            result[setting] = this.settingItems[setting].isChecked()
        }
        return result
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/components/CopySettingsBlock.js